import { render, staticRenderFns } from "./financeiro-taxa-aluguel.vue?vue&type=template&id=6506197f&scoped=true"
import script from "./financeiro-taxa-aluguel.vue?vue&type=script&lang=ts"
export * from "./financeiro-taxa-aluguel.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-taxa-aluguel.vue?vue&type=style&index=0&id=6506197f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506197f",
  null
  
)

export default component.exports